import {Injectable} from '@angular/core';
import {HttpServiceBase} from '../core/services/HttpServiceBase';
import {Category} from '../core/entities/entities';
import {HttpService} from '../core/services/http.service';
import {ServiceName} from '../core/services/Service';

@Injectable()
export class CategoryService extends HttpServiceBase<Category> {
  getCleanInstance(): Category {
    return new Category();
  }

  public hasSingleGet() {
    return false;
  }

  public refreshOnRouteChange() {
    return false;
  }

  constructor(protected http: HttpService) {
    super(http);
  }

  getUrl() {
    return  'category';
  }


}

ServiceName.add('CategoryService', CategoryService);



// WEBPACK FOOTER //
// ./src/app/services/category.service.ts